import FooterPc from "./indexPC";
import FooterM from "./indexM";

const Footer: React.FC = () => {
  return (
    <>
      <div className="desktop-only">
        <FooterPc />
      </div>
      <div className="mobile-only">
        <FooterM />
      </div>
    </>
  );
};

export default Footer;
